import Polling from "../Polling";
import Image from 'next/image';

const Footer = () => {
  return (
    <footer className="text-white py-8 w-full zBg-gradient-1" >
      <div className="relative bg-black-blue__ rounded-2xl mx-auto w-90 lg:w-5/6 3xl:w-[73%] px-4 lg:px-5 py-10 flex flex-col w-full min-h-full">
        <div className="flex flex-wrap justify-between w-full">
          {/* Logo Column */}
          <div className="w-full lg:w-1/5 flex flex-col items-center lg:items-start mb-6 lg:mb-0">
            <Image src="/images/logos/logofooter.png" alt="Logo" width={230} height={51} className="object-contain" />
            <div className="flex justify-center space-x-4 mt-4">
              <a href="#"><Image src="/images/icons/twitter.svg" alt="Twitter" width={24} height={24} /></a>
              <a href="#"><Image src="/images/icons/facebook.svg" alt="Facebook" width={24} height={24} /></a>
              <a href="#"><Image src="/images/icons/instagram.svg" alt="Instagram" width={24} height={24} /></a>
              <a href="#"><Image src="/images/icons/discord.svg" alt="Discord" width={24} height={24} /></a>
              <a href="#"><Image src="/images/icons/telegram.svg" alt="Telegram" width={24} height={24} /></a>
              <a href="#"><Image src="/images/icons/youtube.svg" alt="YouTube" width={24} height={24} /></a>
            </div>
          </div>

          {/* Ecosystem Column */}
          <div className="w-full lg:w-1/5">
            <h3 className="text-[#FF2E29]">ECOSYSTEM</h3>
            <ul className="list-none space-y-1 mt-2">
              <li><a href="#">Trade</a></li>
              <li><a href="#">Earn</a></li>
              <li><a href="#">Game</a></li>
              <li><a href="#">NFTs</a></li>
              <li><a href="#">Tokenomics</a></li>
            </ul>
          </div>

          {/* Developers Column */}
          <div className="w-full lg:w-1/5">
            <h3 className="text-[#FF2E29]">DEVELOPERS</h3>
            <ul className="list-none space-y-1 mt-2">
              <li><a href="#">Contributing</a></li>
              <li><a href="#">GitHub</a></li>
            </ul>
          </div>

          {/* Support Column */}
          <div className="w-full lg:w-1/5">
            <h3 className="text-[#FF2E29]">SUPPORT</h3>
            <ul className="list-none space-y-1 mt-2">
              <li><a href="#">Contact</a></li>
              <li><a href="#">Troubleshooting</a></li>
              <li><a href="#">Documentation</a></li>
            </ul>
          </div>

          {/* About Column */}
          <div className="w-full lg:w-1/5">
            <h3 className="text-[#FF2E29]">ABOUT</h3>
            <ul className="list-none space-y-1 mt-2">
              <li><a href="#">Terms of Service</a></li>
              <li><a href="#">Blog</a></li>
              <li><a href="#">Brand Assets</a></li>
            </ul>
          </div>
        </div>


      </div>
    </footer>

  );
};

export default Footer;
